module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui inverted accordion",
    staticStyle: {
      "padding-top": "10px",
      "max-width": "800px",
      "clear": "both"
    },
    attrs: {
      "id": 'downloadSpreadsheetAccordion' + _vm.variant
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "ui grid",
    staticStyle: {
      "margin-left": "20px",
      "margin-top": "6px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "three wide column"
  }, [_vm._v("Send to")]), _vm._v(" "), _c('div', {
    staticClass: "twelve wide column"
  }, [(_vm.emails.length > 0) ? _c('div', {
    staticClass: "ui inverted form"
  }, _vm._l((_vm.emails), function(e) {
    return _c('div', {
      staticClass: "inline field"
    }, [_c('div', {
      staticClass: "ui checkbox labelCursorFix"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (e.selected),
        expression: "e.selected"
      }],
      attrs: {
        "id": e.email,
        "type": "checkbox",
        "data-lpignore": "true"
      },
      domProps: {
        "checked": Array.isArray(e.selected) ? _vm._i(e.selected, null) > -1 : (e.selected)
      },
      on: {
        "change": function($event) {
          var $$a = e.selected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(e, "selected", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(e, "selected", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(e, "selected", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": e.email
      }
    }, [_vm._v(_vm._s(e.email))])])])
  }), 0) : _c('div', [_vm._v("\n           You have no verified email addresses\n         ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "three wide column"
  }, [_vm._v("Options")]), _vm._v(" "), _c('div', {
    staticClass: "twelve wide column"
  }, [_c('div', {
    staticClass: "ui inverted form"
  }, [_c('div', {
    staticClass: "inline field"
  }, [_c('div', {
    staticClass: "ui checkbox labelCursorFix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.includeAllProducts),
      expression: "includeAllProducts"
    }],
    attrs: {
      "id": "includeAllProducts",
      "type": "checkbox",
      "data-lpignore": "true"
    },
    domProps: {
      "checked": Array.isArray(_vm.includeAllProducts) ? _vm._i(_vm.includeAllProducts, null) > -1 : (_vm.includeAllProducts)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.includeAllProducts,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.includeAllProducts = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.includeAllProducts = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.includeAllProducts = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "includeAllProducts"
    }
  }, [_vm._v("Include ALL my products in the spreadsheet")])])]), _vm._v(" "), _c('div', {
    staticClass: "inline fields"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui radio checkbox labelCursorFix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rangeDays),
      expression: "rangeDays"
    }],
    attrs: {
      "type": "radio",
      "name": "daterange",
      "id": "daterange1",
      "value": "90",
      "checked": "checked"
    },
    domProps: {
      "checked": _vm._q(_vm.rangeDays, "90")
    },
    on: {
      "change": function($event) {
        _vm.rangeDays = "90"
      }
    }
  }), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui radio checkbox labelCursorFix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rangeDays),
      expression: "rangeDays"
    }],
    attrs: {
      "type": "radio",
      "name": "daterange",
      "id": "daterange2",
      "value": "-1"
    },
    domProps: {
      "checked": _vm._q(_vm.rangeDays, "-1")
    },
    on: {
      "change": function($event) {
        _vm.rangeDays = "-1"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "daterange2"
    }
  }, [_vm._v("Custom dates")])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeDown"
    }
  }, [(_vm.rangeDays == -1) ? _c('div', {
    staticClass: "inline field",
    class: _vm.sendPhase === 'DATE_INPUT_ERROR' ? 'error' : ''
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rangeDateFrom),
      expression: "rangeDateFrom"
    }],
    staticStyle: {
      "width": "165px"
    },
    attrs: {
      "name": "datefrom",
      "type": "date",
      "placeholder": "yyyy-mm-dd"
    },
    domProps: {
      "value": (_vm.rangeDateFrom)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rangeDateFrom = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rangeDateTo),
      expression: "rangeDateTo"
    }],
    staticStyle: {
      "width": "165px"
    },
    attrs: {
      "name": "dateto",
      "type": "date",
      "placeholder": "yyyy-mm-dd"
    },
    domProps: {
      "value": (_vm.rangeDateTo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rangeDateTo = $event.target.value
      }
    }
  })]) : _vm._e()])], 1)])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "three wide column"
  }), _vm._v(" "), _c('div', {
    staticClass: "three wide column"
  }, [_c('div', {
    staticClass: "ui primary button",
    class: _vm.sendPhase === 'IN_PROGRESS' ? 'loading' : _vm.selectedEmailAddresses.length == 0 || _vm.emails.length == 0 || _vm.sendPhase === 'OK_FRESH' ? 'disabled' : '',
    on: {
      "click": function($event) {
        return _vm.send()
      }
    }
  }, [_vm._v("Send")])]), _vm._v(" "), _c('div', {
    staticClass: "nine wide column"
  }, [_c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedEmailAddresses.length < 1 && _vm.emails.length > 0),
      expression: "selectedEmailAddresses.length<1 && emails.length > 0"
    }],
    staticStyle: {
      "color": "#777"
    }
  }, [_vm._v("\n                select an email "), _c('br'), _vm._v("\n                address above\n        ")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeDown"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sendPhase === 'OK_FRESH' || _vm.sendPhase === 'FAILED' || _vm.sendPhase === 'TOO_MANY_REQUESTS'),
      expression: "sendPhase === 'OK_FRESH' || sendPhase === 'FAILED' || sendPhase === 'TOO_MANY_REQUESTS'"
    }],
    staticClass: "ui positive message"
  }, [_c('i', {
    staticClass: "close icon"
  }), _vm._v(" "), (_vm.sendPhase === 'OK_FRESH') ? _c('div', {
    staticClass: "header"
  }, [_vm._v("\n            Your request has been received\n          ")]) : _vm._e(), _vm._v(" "), (_vm.sendPhase === 'OK_FRESH') ? _c('p', [_vm._v("The spreadsheet will be delivered to your inbox in a couple of minutes.")]) : _vm._e(), _vm._v(" "), (_vm.sendPhase === 'TOO_MANY_REQUESTS') ? _c('div', [_vm._v("The system is already compiling a spreadsheet for you, please try again in a couple of minutes.")]) : _vm._e(), _vm._v(" "), (_vm.sendPhase === 'FAILED') ? _c('div', [_vm._v("Could not send request")]) : _vm._e()])])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title",
    staticStyle: {
      "font-size": "1.3em"
    }
  }, [_vm._v("\n         \n    "), _c('i', {
    staticClass: "dropdown icon"
  }), _vm._v(" "), _c('i', {
    staticClass: "olive large chart bar icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "daterange1"
    }
  }, [_vm._v("Last 90 days    "), _c('span', {
    staticStyle: {
      "color": "#777"
    }
  }, [_vm._v("- or -")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "three wide column"
  }), _vm._v(" "), _c('div', {
    staticClass: "thirteen wide column",
    staticStyle: {
      "font-size": ".9em"
    }
  }, [_vm._v("\n         This feature is currently in [Preview] - we are likely to change / add things to it."), _c('br'), _vm._v("\n         Is there something you'd like to see in the generated spreadsheets? Let us know by sending a feature request. "), _c('br'), _c('br'), _vm._v("\n         Also, while in preview: date range is 120 days max, earliest date is 60 days before signing up to SentryKit. (Need more? Contact us to lift your limits.)\n       ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3a229159!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SpreadsheetDownloadWidget.vue
// module id = 752
// module chunks = 2